<!--<div class="modal-header">-->
<!--  <h5 class="modal-title">Order Details</h5>-->
<!--  <button type="button" class="close" aria-label="Close" (click)="closeModal()">-->
<!--    <span aria-hidden="true">&times;</span>-->
<!--  </button>-->
<!--</div>-->
<!--<div class="modal-body">-->
<!--  <p>Order ID: {{ order.id }}</p>-->
<!--  <p>Start Time: {{ order.start | date:'dd.MM.yy HH:mm' }}</p>-->
<!--  <p>End Time: {{ order.end | date:'dd.MM.yy HH:mm' }}</p>-->
<!--  <p>Work Places: {{ order.workPlaces }}</p>-->
<!--  <p>Status: {{ order.status }}</p>-->
<!--  &lt;!&ndash; Add more order details as needed &ndash;&gt;-->
<!--</div>-->
<!--<div class="modal-footer">-->
<!--  <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>-->
<!--</div>-->

<div class="modal-header">
  <h5 class="modal-title">Add Visitor</h5>
  <span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="visitorForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="firstname">First Name</label>
              <input type="text" id="firstname" class="form-control" formControlName="firstname">
            </div>
            <div class="col-md-6 mb-3">
              <label for="lastname">Last Name</label>
              <input type="text" id="lastname" class="form-control" formControlName="lastname">
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="phone">Phone</label>
              <input type="text" id="phone" class="form-control" formControlName="phone">
            </div>
            <div class="col-md-6 mb-3">
              <label for="email">Email</label>
              <input type="email" id="email" class="form-control" formControlName="email">
            </div>
          </div>
          <div class="form-row" *ngIf="showAdminFields">
            <div class="col-md-6 mb-3">
              <label for="phone">Office</label>
              <select id="officeId" class="form-control" formControlName="officeId">
                <option *ngFor="let office of offices" [value]="office.id">{{ office.city + ' ' + office.address }}</option>
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label for="email">Room</label>
              <select id="roomId" class="form-control" formControlName="roomId">
                <option *ngFor="let room of rooms" [value]="room.id">{{ room.name }}</option>
              </select>
            </div>
          </div>

          <div class="form-row" *ngIf="showAdminFields">
            <div class="col-md-6 mb-3">
              <label for="phone">Option</label>
              <select id="bookingOption" class="form-control" formControlName="bookingOption">
                <option *ngFor="let bookingOption of bookingOptions" [value]="bookingOption">{{ bookingOption }}</option>
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label for="email">Date</label>
              <div class="input-group">
                <input type="text" id="expirationDate" name="expirationDate" class="form-control" placeholder="dd.mm.yyyy"
                       ngbDatepicker #ed="ngbDatepicker" firstDayOfWeek="0" [minDate]="minDate"
                       formControlName="expirationDate">
                <button class="btn btn-outline-secondary calendar" (click)="ed.toggle()" type="button" [disabled]="ed.disabled">
                  <i class="fas fa-calendar"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-outline-info add-edit-button" (click)="saveVisitor()">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
